"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const Drawer_1 = __importDefault(require("@atg/icf-react-components/components/Drawer"));
const FlatButton_1 = __importDefault(require("@atg/icf-react-components/components/FlatButton"));
const Flex_1 = __importDefault(require("@atg/icf-react-components/components/Flex"));
const IconButton_1 = __importDefault(require("@atg/icf-react-components/components/IconButton"));
const RaisedButton_1 = __importDefault(require("@atg/icf-react-components/components/RaisedButton"));
const Text_1 = __importDefault(require("@atg/icf-react-components/components/Text"));
const react_1 = __importStar(require("react"));
const overrides_1 = require("./overrides");
const FedmodBadge = ({ clientNames, wrapperProps, drawerProps, children, ...props }) => {
    clientNames = clientNames.map((name) => name.replace("_client", ""));
    const [open, setOpen] = (0, react_1.useState)(false);
    const [overrides, setOverrides] = (0, react_1.useState)(() => (0, overrides_1.getOverrides)(clientNames));
    (0, react_1.useEffect)(() => {
        const list = (0, overrides_1.parseSearchParams)(location.href, clientNames);
        if (list.size > 0) {
            setOverrides((0, overrides_1.getOverrides)(clientNames));
        }
    }, [clientNames]);
    if (!overrides.size) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Flex_1.default, { position: "relative", width: "fit-content", ...wrapperProps },
            children,
            react_1.default.createElement(Flex_1.default, { position: "absolute", right: "-20", top: "-20", ...props },
                react_1.default.createElement(IconButton_1.default, { name: "warning", type: "warning", selected: true, onClick: () => setOpen((prev) => !prev) }))),
        react_1.default.createElement(Drawer_1.default, { open: open, onClose: () => setOpen(false), anchor: "bottom", disableCloseButton: false, padding: "$2", width: "500", ...drawerProps },
            react_1.default.createElement(Flex_1.default, { gap: "$3" },
                react_1.default.createElement(Text_1.default, { variant: "heading_m" }, "Fedmod Overrides"),
                Array.from(overrides).map(([name, url]) => {
                    return (react_1.default.createElement(Flex_1.default, { key: name, direction: "row", justifyContent: "space-between" },
                        react_1.default.createElement(Flex_1.default, { gap: "$1" },
                            react_1.default.createElement(Text_1.default, { variant: "heading_xs" }, name),
                            react_1.default.createElement(Text_1.default, { variant: "body_s", color: "baseContrast050" }, url)),
                        react_1.default.createElement(FlatButton_1.default, { size: "small", onClick: () => {
                                (0, overrides_1.removeOverride)(name);
                                location.reload();
                            } }, "Clear")));
                }),
                react_1.default.createElement(RaisedButton_1.default, { onClick: () => {
                        (0, overrides_1.resetOverrides)(clientNames);
                        location.reload();
                    } }, "Clear all")))));
};
exports.default = FedmodBadge;
